import { useApi } from '@/api';
import {
  ActivityCard,
  EntityName,
  KpiCard,
  Page,
  PageSkeleton
} from '@/components';
import { tokensMappingBase } from '@/utils/tokens';
import { CryptoIcon, Flex, Heading } from '@blockanalitica/ui';
import BridgeHistoricGraph from './BridgeHistoricGraph';

export default function BaseBridgePage() {
  const [data, error] = useApi({
    url: '/base/'
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={<CryptoIcon name={'weth'} size="3" />}
            symbol2={<CryptoIcon name={'base'} size="3" />}>
            <Heading size="1">
              <Flex gap="xs">SkyLink</Flex>
            </Heading>
          </EntityName>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Assets Bridged"
            data={data}
            field="total_bridge_balance"
            options={{ currency: 'USD' }}
          />
        </Flex>
        <BridgeHistoricGraph />
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Bridged USDS"
            data={data}
            field="usds_bridge_balance"
            variant="usds"
            options={{
              currency: tokensMappingBase('USDS')
            }}
          />

          <KpiCard
            title="Bridged sUSDS"
            data={data}
            field="susds_bridge_balance"
            variant="susds"
            options={{
              currency: tokensMappingBase('sUSDS')
            }}
          />
        </Flex>
        <ActivityCard url={`/base/bridge/activity/`} linkTo="activity" />
      </Page>
    );
  }
  return <PageSkeleton />;
}
